/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Olive_Quiet_Bee_JumpInputs */

const en_olive_quiet_bee_jump = /** @type {(inputs: Olive_Quiet_Bee_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removed`)
};

const de_olive_quiet_bee_jump = /** @type {(inputs: Olive_Quiet_Bee_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernt`)
};

/**
* | output |
* | --- |
* | "Removed" |
*
* @param {Olive_Quiet_Bee_JumpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const olive_quiet_bee_jump = /** @type {((inputs?: Olive_Quiet_Bee_JumpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Olive_Quiet_Bee_JumpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_olive_quiet_bee_jump(inputs)
	return de_olive_quiet_bee_jump(inputs)
});